/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SeoHead from "../../section/SeoHead";
import ProfileSidebar from "../layout/ProfileSidebar";
import ProfileContent from "../layout/ProfileContent";
import { profileConfigs } from "../../../config/profileConfig";
import { Link } from "react-router-dom";

const ParalegalProfile = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const config = profileConfigs.paralegal;
  const role = config.role;

  useEffect(() => {
    const storedUser = localStorage.getItem("auth_user");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      setUserData({
        ...parsed,
        role,
        isLawFirm: false,
        firmDetails: {
          contactNumber: parsed.phone || "+1 (555) 456-7890",
          address: "123 Legal Plaza, Suite 200, Los Angeles, CA 90210",
          establishedYear: "2015",
          specialties: ["Immigration Law", "Family Law"],
          licenseNumber: "PAR-2018-987654",
        },
      });
    }
    setLoading(false);
  }, []);

  if (loading || !userData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Paralegal Profile - Citizen Hub",
    description: "Manage your paralegal profile and assigned forms.",
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SeoHead
        title="Paralegal Profile - Citizen Hub"
        description="Manage your profile and assigned legal forms."
        canonicalUrl="https://citizenhub.com/profile/paralegal"
        structuredData={structuredData}
      />

      <section className="py-16 bg-gray-50 min-h-screen">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to={"/"}
            className="mb-[10px] block w-fit text-center px-6 py-3 rounded-[4px] bg-blue-600 text-white font-semibold shadow-md transition-all duration-200"
          >
            ←
            Back To Home
          </Link>
          <div className="flex flex-col lg:flex-row gap-8">
            <ProfileSidebar
              userData={userData}
              tabs={config.tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
            <ProfileContent
              activeTab={activeTab}
              userData={userData}
              setUserData={setUserData}
              role={role}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ParalegalProfile;